import { t, useI18n } from "@bookingcom/lingojs-react";
import { ErrorPage } from "../components/ErrorPage";

export const NotFoundComponent = () => {
  const i18n = useI18n();

  return (
    <ErrorPage
      title={i18n.trans(t("flights_airline_portal_airline_view_not_found_header"))}
      description={i18n.trans(t("flights_airline_portal_airline_view_not_found_body"))}
    />
  );
};
